import {
  Box,
  Button,
  Container,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
} from '@chakra-ui/react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import FlareGroup1 from '../../assets/shapes/shape-group-1.svg';
import { GetOffer, HalfByHalfSection } from '../_index';

// To receive a FREE fast fair offer TODAY, please fill in the form to the right or give us a call...

// We Buy Houses in the Bay Area in any condition. No realtors, no fees, no commission and best of all, no repairs or cleaning necessary. Get Your No-Obligation
//  All Cash Offer Started Below!

const HeroHeader = () => (
  <Box
    flexBasis={{ base: '100%', md: '50%' }}
    px={{ base: 0, md: 6 }}
  >
    <Heading
      as="h2"
      maxWidth="800px"
      size="2xl"
      lineHeight="base"
      mb={4}
    >
      We offer a quick and easy way to sell your home without a realtor
      {' '}
      <span className="highlight">100%&nbsp;FREE</span>
    </Heading>
    <Heading
      variant="sec"
      as="h1"
      size="lg"
      lineHeight="base"
      mb={10}
      maxWidth="600px"
    >
      {' '}
      We Buy Houses in the Bay Area in any condition. To receive a
      {' '}
      <span className="highlight">FREE, fast, and fair offer today</span>
      ,
      please fill in the form or give us a call.
    </Heading>
    {/* <Heading
      py="6"
      px="4"
      rounded="lg"
      backgroundColor="brand.five"
      variant="sec"
      as="h3"
      size="lg"
      lineHeight="base"
    /> */}
  </Box>
);

const GetOfferHeroBlock = ({ img }) => (
  <Box>
    <GetOffer />
    <Box
      position="relative"
      mt={4}
      transform={{ base: 'scale(.8)', md: 'scale(.8)' }}
      display={{ base: 'none', md: 'block' }}
    >
      <Box
        position="absolute"
        top="20%"
        left="20%"
      >
        {/* <GatsbyImage
          className="width-300"
          alt="happy home buyers image"
          image={img}
        /> */}
      </Box>
      <FlareGroup1 className="width-500 height-500" />
    </Box>
  </Box>
);

const HeroHome = ({ data }) => {
  const { heroImage, flareImage } = useStaticQuery(query);
  const hero = getImage(heroImage);
  const flare = getImage(flareImage);
  return (
    <HalfByHalfSection
      left={<HeroHeader />}
      right={<GetOfferHeroBlock img={hero} />}
    />
  );
};

export const query = graphql`
  query {
    heroImage: file(relativePath: { eq: "people/happy.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
    flareImage: file(relativePath: { eq: "illustrations/ellipse-5.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
  }
`;

export default HeroHome;
